import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53057c20")

_pushScopeId("data-v-53057c20")
const _hoisted_1 = { class: "aOwner" }
const _hoisted_2 = { class: "platformTaxpayer" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "纳税人信息", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "万元", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "个", -1)
const _hoisted_6 = { class: "platformFinancial" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", null, "财务信息", -1)
const _hoisted_8 = { class: "platformTax" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", null, "办税信息", -1)
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "是否推送数据？", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      labelCol: { style: 'width: 250px' },
      model: _ctx.formState,
      rules: _ctx.rules
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_row, { class: "platformTaxpayerRow" }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "纳税人名称:",
                class: "aManagementInput",
                name: "nsrmc"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.nsrmc,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formState.nsrmc = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入纳税人名称"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "纳税人识别号:",
                class: "aManagementInput",
                name: "nsrsbh"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.nsrsbh,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formState.nsrsbh = $event)),
                    style: {"width":"220px"},
                    placeholder: "纳税人识别号"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "行业:",
                class: "aManagementInput",
                name: "hy"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    style: {"width":"220px"},
                    value: _ctx.formState.hy,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formState.hy = $event)),
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onSearch: _ctx.handleSearch,
                    placeholder: "请选择行业"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.verifyStatedOptions, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onSearch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "纳税人状态:",
                class: "aManagementInput",
                name: "nsrzt"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    style: {"width":"220px"},
                    value: _ctx.formState.nsrzt,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formState.nsrzt = $event)),
                    placeholder: "请输入纳税人状态"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "主管税务局:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    value: _ctx.formState.zgswjgName,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formState.zgswjgName = $event)),
                    placeholder: "请输入主管税务局",
                    style: {"width":"220px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onChange: _ctx.handleChange1,
                    onSearch: _ctx.handleSearchCertificate
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taxOffice, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "onSearch"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "主管税务所:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    value: _ctx.formState.zgswskfjName,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formState.zgswskfjName = $event)),
                    placeholder: "请输入主管税务所",
                    style: {"width":"220px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onChange: _ctx.handleChange3,
                    onSearch: _ctx.handleSearchCertificate
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taxOffice, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "onSearch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "法人姓名:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.fddbrxm,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formState.fddbrxm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入法人姓名"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "法人证件种类:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    style: {"width":"220px"},
                    value: _ctx.formState.fddbrsfzjzl,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formState.fddbrsfzjzl = $event)),
                    placeholder: "请选择法人证件种类"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personCertificate, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "法人身份证号:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.fddbrsfzjhm,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formState.fddbrsfzjhm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入法人身份证号"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "法人移动电话:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.fddbryddh,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formState.fddbryddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入法人移动电话"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "法人固定电话:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.fddbrgddh,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formState.fddbrgddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入法人固定电话"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "注册资本:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.zczb,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formState.zczb = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入注册资本"
                  }, null, 8, ["value"]),
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "注册地址:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.zcdz,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formState.zcdz = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入注册地址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "街道乡镇:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.jdxz,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formState.jdxz = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入街道乡镇"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "注册地址行政区划:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    value: _ctx.formState.zcdzxzqhName,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formState.zcdzxzqhName = $event)),
                    placeholder: "请输入注册地址行政区划",
                    style: {"width":"220px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onChange: _ctx.handleChange2,
                    onSearch: _ctx.handleSearchCertificateQu
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taxOfficeQu, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "onSearch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "生产经营地址:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.scjydz,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formState.scjydz = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入生产经营地址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "经营范围:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.jyfw,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formState.jyfw = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入经营范围"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "生产经营地址行政区划:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    value: _ctx.formState.scjydzxzqhName,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formState.scjydzxzqhName = $event)),
                    placeholder: "请输入生产经营地址行政区划",
                    style: {"width":"220px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onChange: _ctx.handleChange,
                    onSearch: _ctx.handleSearchCertificateQu
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taxOfficeQu, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "onSearch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "法人邮箱:",
                class: "aManagementInput",
                name: "fddbrdzxx"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.fddbrdzxx,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formState.fddbrdzxx = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入法人邮箱"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "网址:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.wz,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formState.wz = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入网址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "从业人数:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.cyrs,
                    "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formState.cyrs = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入从业人数"
                  }, null, 8, ["value"]),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_a_row, { class: "platformTaxpayerRow" }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "财务负责人姓名:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.cwfzrxm,
                    "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.formState.cwfzrxm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入财务负责人姓名"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "财务负责人身份证件种类:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    style: {"width":"220px"},
                    value: _ctx.formState.cwfzrsfzjzl,
                    "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.formState.cwfzrsfzjzl = $event)),
                    placeholder: "请选择财务负责人身份证件种类"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personCertificate, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "财务负责人身份证号码:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.cwfzrsfzjhm,
                    "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => (_ctx.formState.cwfzrsfzjhm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入财务负责人身份证号码"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "财务负责人移动电话:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.cwfzryddh,
                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (_ctx.formState.cwfzryddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入财务负责人移动电话"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "财务负责人固定电话:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.cwfzrgddh,
                    "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => (_ctx.formState.cwfzrgddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入财务负责人固定电话"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "财务负责人电子信箱:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.cwfzrdzxx,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (_ctx.formState.cwfzrdzxx = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入财务负责人电子信箱"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_a_row, { class: "platformTaxpayerRow" }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "办税人姓名:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.bsrxm,
                    "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => (_ctx.formState.bsrxm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入办税人姓名"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "办税人身份证件种类:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    style: {"width":"220px"},
                    value: _ctx.formState.bsrsfzjzl,
                    "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => (_ctx.formState.bsrsfzjzl = $event)),
                    placeholder: "请选择办税人身份证件种类"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personCertificate, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "办税人身份证号码:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.bsrsfzjhm,
                    "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => (_ctx.formState.bsrsfzjhm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入办税人身份证号码"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "办税人移动电话:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.bsryddh,
                    "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => (_ctx.formState.bsryddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入办税人移动电话"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "办税人固定电话:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.bsrgddh,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => (_ctx.formState.bsrgddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入办税人固定电话"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "税务代理人:",
                class: "aManage"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.swdlrmc,
                    "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => (_ctx.formState.swdlrmc = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入税务代理人"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "办税人电子信箱:",
                name: "bsrdzxx",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.bsrdzxx,
                    "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => (_ctx.formState.bsrdzxx = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入办税人电子信箱"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_a_button, {
            onClick: _ctx.save,
            class: "aManageQuery",
            type: "primary"
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visibleTitle,
      title: "推送",
      width: "450px",
      centered: "true",
      maskClosable: "false",
      okText: "确定",
      cancelText: "取消",
      onOk: _ctx.handleOk,
      onCancel: _cache[35] || (_cache[35] = () => { _ctx.visibleTitle = false })
    }, {
      default: _withId(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
})